function States({totals}) {
    return (
        <div id="states" className="align-self-center align-self-md-end">
            <ul className="list-group list-unstyled list-group-horizontal align-items-end">
            {Object.keys(totals).map((state, idx) => (
                <li key={idx}>
                    <div className="bar" style={{height: totals[state] * 10 + 24}}>{totals[state]}</div>
                    <span>{state}</span>
                </li>
            ))}
            </ul>
        </div>
    );
}

export default States;